import { SAVE_WISHLIST_DATA } from "../ActionTypes/wishlist";

const initialState: any = {
  data: [],
};

const wishlistReducer = (state: any = initialState, action: any) => {
  switch (action.type) {
    case SAVE_WISHLIST_DATA:
      return { ...state, data: action.data };
    default:
      return state;
  }
};

export default wishlistReducer;
